import React, { useState, useEffect, useContext } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { GrupoContext } from "../GrupoContext";
import Sidebar from "../componenteExtra/SidebarSolicitante";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement("#root");

const RevisarActividadSolicitante = () => {
  const { grupo: solicitanteGrupo } = useContext(GrupoContext);
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comentario, setComentario] = useState("");
  const [isRejection, setIsRejection] = useState(false);
  const [fechaCompletadaActividad, setFechaCompletadaActividad] = useState("");
  const [bitacoraRechazos, setBitacoraRechazos] = useState([]);
  const [isBitacoraModalOpen, setIsBitacoraModalOpen] = useState(false);
  const navigate = useNavigate();
  const [nombre_get, setNombreGet] = useState("");

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Obtener el nombre_get desde el localStorage
    const storedNombreGet = localStorage.getItem("nombre_get");
    setNombreGet(storedNombreGet);
  }, []);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/my_assignments6/${nombre_get}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setActivities(response.data);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  }, [nombre_get]);

  const handleReview = (activity) => {
    setSelectedActivity(activity);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedActivity(null);
    setComentario("");
    setIsRejection(false);
  };

  const handleAccept = () => {
    if (!fechaCompletadaActividad) {
      toast.error(
        "Por favor selecciona una fecha para completar la actividad.",
      );
      return;
    }

    const toastId = toast.loading("Aceptando actividad...");

    axios.post(`${process.env.REACT_APP_BACKEND_URL}/complete_activity`,{
          id: selectedActivity.id,
          codigo_proyecto: selectedActivity.codigo_proyecto,
          nombre_proyecto: selectedActivity.nombre_proyecto,
          razon_social: selectedActivity.razon_social,
          filial: selectedActivity.filial,
          encargado_auditoria: selectedActivity.encargado_auditoria,
          numero_grupo: selectedActivity.numero_grupo,
          jefe_grupo: selectedActivity.jefe_grupo,
          subrogante: selectedActivity.subrogante,
          rubro_get: selectedActivity.rubro_get,
          nombre_actividad_get: selectedActivity.nombre_actividad_get,
          staff_asignado: selectedActivity.staff_asignado,
          fecha_inicio_trabajo_staff: selectedActivity.fecha_inicio_trabajo_staff,
          fecha_completada_actividad: fechaCompletadaActividad,
          horas_get: selectedActivity.horas_get,
          horas_estandar: selectedActivity.horas_estandar,
          fecha_inscripción_actividad: selectedActivity.fecha_inscripción_actividad,
          fecha_documentación_actividad: selectedActivity.fecha_documentación_actividad,
          fecha_asignada_actividad: selectedActivity.fecha_asignada_actividad,
          fecha_entrega_informacion: selectedActivity.fecha_entrega_informacion,
          fecha_termino_senior_actividad: selectedActivity.fecha_termino_senior_actividad,
          nombre_solicitante: selectedActivity.nombre_solicitante,
          tipo_regulacion: selectedActivity.tipo_regulacion
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => {
        toast.dismiss(toastId);
        toast.success("Actividad aceptada y completada");
        handleCloseModal();
        setActivities(
          activities.filter((activity) => activity.id !== selectedActivity.id),
        );
      })
      .catch((error) => {
        toast.dismiss(toastId);
        toast.error("Error al aceptar la actividad");
        console.error("Error accepting activity:", error);
      });
  };

  const handleReject = () => {
    if (comentario.length < 20) {
      toast.error("El comentario debe tener al menos 20 caracteres."); // Mostrar toaster de error si el comentario es muy corto
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/reject_activity3`,
        {
          id: selectedActivity.id,
          estados_staff: selectedActivity.estados_staff - 3,
          comentario_solicitante: comentario,
          rol: `Solicitante`
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      ) // Enviar el rol rechazador como 'Solicitante'
      .then((response) => {
        toast.success("Actividad rechazada"); // Mostrar toaster de éxito
        handleCloseModal();
        setActivities(
          activities.filter((activity) => activity.id !== selectedActivity.id),
        );
      })
      .catch((error) => {
        console.error("Error rejecting activity:", error);
        toast.error("Error al rechazar la actividad"); // Mostrar toaster de error
      });
  };

  const handleShowRejection = () => {
    setIsRejection(true);
  };

  const handleShowBitacora = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/bitacora_rechazos/${selectedActivity.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setBitacoraRechazos(response.data);
        setIsBitacoraModalOpen(true);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          toast.error("Esta actividad no tiene rechazos registrados"); // Mostrar toaster si no hay rechazos
        } else {
          console.error("Error fetching bitacora:", error);
        }
      });
  };

  const handleCloseBitacoraModal = () => {
    setIsBitacoraModalOpen(false);
  };

  const totalActividades = activities.length;

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Revisar solicitudes - {nombre_get}</h1>
          <h2>Total Actividades: {totalActividades}</h2>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Código de Proyecto</th>
                  <th>Razón Social</th>
                  <th>Filial</th>
                  <th>Tipo de trabajo</th>
                  <th>Regulación</th>
                  <th>Socio de auditoría</th>
                  <th>Rubro GET</th>
                  <th>Nombre Actividad GET</th>
                  <th>Jefe de Grupo</th>
                  <th>Subrogante</th>
                  <th>Fecha de Entrega de Información</th>
                  <th>Fecha Inicio</th>
                  <th>Fecha Termino</th>
                  <th>Fecha Inicio Staff</th>
                  <th>Horas GET</th>
                  <th>Horas Estándar</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {activities.map((activity, index) => (
                  <tr key={index}>
                    <td>{activity.codigo_proyecto}</td>
                    <td>{activity.razon_social}</td>
                    <td>{activity.filial}</td>
                    <td>{activity.tipo_solicitud}</td>
                    <td>{activity.tipo_regulacion}</td>
                    <td>{activity.encargado_auditoria}</td>
                    <td>{activity.rubro_get}</td>
                    <td>{activity.nombre_actividad_get}</td>
                    <td>{activity.jefe_grupo}</td>
                    <td>{activity.subrogante}</td>
                    <td>{activity.fecha_entrega_informacion}</td>
                    <td>{activity.fecha_de_inicio}</td>
                    <td>{activity.fecha_de_termino}</td>
                    <td>{activity.fecha_inicio_trabajo_staff}</td>
                    <td>{activity.horas_get}</td>
                    <td>{activity.horas_estandar}</td>
                    <td>
                      <button
                        className="action-button"
                        onClick={() => handleReview(activity)}
                      >
                        Revisar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {selectedActivity && (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          style={{
            content: {
              backgroundColor: "#f9f9f9",
              borderRadius: "10px",
              padding: "20px",
              maxWidth: "500px",
              width: "220%",
              margin: "0 auto",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
        >
          <h1 style={{ color: "#333", marginBottom: "20px" }}>
            Revisar actividad
          </h1>
          <h2>
            <strong>Staff: </strong> {selectedActivity.staff_asignado}
          </h2>
          <p>
            <strong>Código de proyecto:</strong>{" "}
            {selectedActivity.codigo_proyecto}
          </p>
          <p>
            <strong>Nombre de proyecto:</strong>{" "}
            {selectedActivity.nombre_proyecto}
          </p>
          <p>
            <strong>Razón social:</strong> {selectedActivity.razon_social}
          </p>
          <p>
            <strong>Rubro GET:</strong> {selectedActivity.rubro_get}
          </p>
          <p>
            <strong>Nombre actividad GET:</strong>{" "}
            {selectedActivity.nombre_actividad_get}
          </p>
          <p>
            <strong>Enlace comentario:</strong>{" "}
            {selectedActivity.enlace_comentario}
          </p>
          <h2>
            <strong>Último comentario SeniorGET: </strong>{" "}
            {selectedActivity.comentario_seniorGET}
          </h2>
          <h2>
            <strong>Último comentario Lider: </strong>{" "}
            {selectedActivity.comentario_lider}
          </h2>
          <p>
            <strong>Ingrese la fecha actual si la actividad es aceptada: </strong>
            <input
              type="date"
              value={fechaCompletadaActividad}
              onChange={(e) => setFechaCompletadaActividad(e.target.value)}
            />
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <button
              onClick={handleAccept}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Aceptar
            </button>
            <button
              onClick={handleShowRejection}
              style={{
                backgroundColor: "#f44336",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Rechazar
            </button>
            <button
              onClick={handleShowBitacora}
              style={{
                backgroundColor: "#2196F3",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Ver Bitácora
            </button>
          </div>

          {isRejection && (
            <div style={{ marginTop: "20px" }}>
              <textarea
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                placeholder="Escriba un comentario..."
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  marginBottom: "10px",
                }}
              />
              <button
                onClick={handleReject}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Enviar
              </button>
            </div>
          )}
        </Modal>
      )}
      {isBitacoraModalOpen && (
        <Modal
          isOpen={isBitacoraModalOpen}
          onRequestClose={handleCloseBitacoraModal}
        >
          <h1>Bitácora de la Actividad</h1>
          {bitacoraRechazos.length > 0 ? (
            <table className="bitacora-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Fecha</th>
                  <th>Rol</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {bitacoraRechazos.map((rechazo, index) => (
                  <tr key={index}>
                    <td>{rechazo.tipo}</td>
                    <td>{rechazo.fecha}</td>
                    <td>{rechazo.rol}</td>
                    <td>{rechazo.comentario}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No hay registros para esta actividad.</p>
          )}
          <button onClick={handleCloseBitacoraModal}>Cerrar</button>
        </Modal>
      )}
      <Toaster />
    </div>
  );
};

export default RevisarActividadSolicitante;
